import { memo } from 'react';
import { selectIsExportMerchantPayoutsLoading } from 'features/merchantPayouts/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';
import UploadSettlement from './UploadSettlement';

const SettlementsImportHistoryTableToolbar = ({ onExport }: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        onExport={onExport}
        selectIsExportLoading={selectIsExportMerchantPayoutsLoading}
        add={UploadSettlement}
    />
);

export default memo(SettlementsImportHistoryTableToolbar);
